export enum EntityTypes {
  ROOM,
  TABLE,
  SPA_DAY,
  TREATMENT,
  FACILITY,
  SPA_CLASS,
  PRODUCT,
  VOUCHER,
  EVENT,
  SPA_EXPERIENCE,
}
